"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dequeue = void 0;
var utils = require("../util/utils");
var constants_1 = require("../constants");
var emitter_1 = require("../util/emitter");
var Dequeue = /** @class */ (function (_super) {
    __extends(Dequeue, _super);
    function Dequeue(record) {
        var _this = _super.call(this) || this;
        _this.record = record;
        _this.debugId = _this.record.getDebugId();
        _this.wrappedFunctions = new Map();
        _this.headPath = 'h';
        _this.emptyHead = { p: '', n: '' };
        _this.hasAddListener = false;
        _this.hasRemoveListener = false;
        _this.hasMoveListener = false;
        _this.subscriptions = [];
        _this.lastEntries = [];
        _this.lastVersion = 0;
        _this.originalApplyUpdate = _this.record.applyUpdate.bind(_this.record);
        _this.record.applyUpdate = _this.applyUpdate.bind(_this);
        _this.record.addReference(_this);
        _this.record.on('discard', function () { return _this.emit('discard', _this); }, _this);
        _this.record.on('delete', function () { return _this.emit('delete', _this); }, _this);
        _this.record.on('error', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.emit.apply(_this, __spreadArray(['error'], __read(args), false));
        }, _this);
        return _this;
    }
    Object.defineProperty(Dequeue.prototype, "name", {
        get: function () {
            return this.record.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Dequeue.prototype, "isReady", {
        get: function () {
            return this.record.isReady;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Dequeue.prototype, "version", {
        get: function () {
            return this.record.version;
        },
        enumerable: false,
        configurable: true
    });
    Dequeue.prototype.whenReady = function (callback) {
        if (callback) {
            this.record.whenReady(this, callback);
        }
        else {
            return this.record.whenReady(this);
        }
    };
    Dequeue.prototype.discard = function () {
        this.destroy();
        this.record.removeReference(this);
    };
    Dequeue.prototype.delete = function (callback) {
        this.destroy();
        return this.record.delete(callback);
    };
    /**
     * Returns the array of list entries or an
     * empty array if the list hasn't been populated yet.
     */
    Dequeue.prototype.getEntries = function () {
        // did we computed already?
        if (this.version === this.lastVersion) {
            return this.lastEntries;
        }
        var head = this.record.get(this.headPath) || this.emptyHead;
        var next = head.n;
        var entries = [];
        while (next) {
            var node = this.record.get(next);
            entries.push(node.d);
            next = node.n;
        }
        // memoize
        this.lastVersion = this.version;
        this.lastEntries = entries;
        return entries;
    };
    /**
   * Returns true if the list is empty
   */
    Dequeue.prototype.isEmpty = function () {
        var head = this.record.get(this.headPath) || this.emptyHead;
        return !head.n && !head.p;
    };
    Dequeue.prototype.setEntriesWithAck = function (entries, callback) {
        var _this = this;
        if (!callback) {
            return new Promise(function (resolve, reject) {
                _this.setEntries(entries, function (error) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve();
                    }
                });
            });
        }
        this.setEntries(entries, callback);
    };
    /**
    * Updates the list with a new set of entries
    */
    Dequeue.prototype.setEntries = function (entries, callback) {
        var _a, _b;
        var errorMsg = 'entries must be an array';
        if (!(entries instanceof Array)) {
            throw new Error(errorMsg);
        }
        if (entries.length === 0) {
            this.record.set({ data: (_a = {}, _a[this.headPath] = this.emptyHead, _a), callback: callback });
            return;
        }
        var head = { n: '0', p: "".concat(entries.length - 1) };
        var nodes = {};
        for (var index = 0; index < entries.length; index++) {
            nodes[index] = {
                d: entries[index],
                n: "".concat(index + 1),
                p: "".concat(index - 1)
            };
            if (index === 0) {
                /* tslint:disable:no-string-literal */
                nodes[index]['p'] = '';
                /* tslint:enable:no-string-literal */
            }
            if (index === entries.length - 1) {
                /* tslint:disable:no-string-literal */
                nodes[index]['n'] = '';
                /* tslint:enable:no-string-literal */
            }
        }
        this.beforeChange();
        this.record.set({ data: __assign((_b = {}, _b[this.headPath] = head, _b), nodes), callback: callback });
        this.afterChange();
    };
    /**
     * Get last entry
     */
    Dequeue.prototype.getLast = function () {
        var head = this.record.get(this.headPath) || this.emptyHead;
        if (!head.p)
            return '';
        var node = this.record.get(head.p);
        return node.d;
    };
    /**
     * Get first entry
     */
    Dequeue.prototype.getFirst = function () {
        var head = this.record.get(this.headPath) || this.emptyHead;
        if (!head.n)
            return '';
        var node = this.record.get(head.n);
        return node.d;
    };
    /**
     * Remove last value and return it
     *
     */
    Dequeue.prototype.pop = function () {
        // when the array is 1 or 2 entries its easier to just set it again to avoid complications with the head reference
        var entries = this.getEntries();
        if (entries.length < 3) {
            var pop = entries.pop() || '';
            this.setEntries(entries);
            return pop;
        }
        var head = this.record.get(this.headPath) || this.emptyHead;
        if (!head.p)
            return '';
        var last = this.record.get(head.p);
        this.beforeChange();
        // update head
        this.record.set({ path: "".concat(this.headPath, ".p"), data: last.p });
        // update last node
        if (last.p)
            this.record.set({ path: "".concat(last.p, ".n"), data: '' });
        // erase node
        this.record.set({ path: head.p, data: undefined });
        this.afterChange();
        return last.d;
    };
    /**
     * Remove first value and return it
     */
    Dequeue.prototype.shift = function () {
        // when the array is 1 or 2 entries its easier to just set it again to avoid complications with the head reference
        var entries = this.getEntries();
        if (entries.length < 3) {
            var shift = entries.shift() || '';
            this.setEntries(entries);
            return shift;
        }
        var head = this.record.get(this.headPath) || this.emptyHead;
        if (!head.n)
            return '';
        var first = this.record.get(head.n);
        this.beforeChange();
        // update head
        this.record.set({ path: "".concat(this.headPath, ".n"), data: first.n });
        // update first node
        if (first.n)
            this.record.set({ path: "".concat(first.n, ".p"), data: '' });
        // erase node
        this.record.set({ path: head.n, data: undefined });
        this.afterChange();
        return first.d;
    };
    /**
     * Get first available key for inserting node
     */
    Dequeue.prototype.getNodeKey = function () {
        var sortedKeys = Object.keys(this.record.get()).sort(function (a, b) { return Number(a) - Number(b); });
        var key = "".concat(sortedKeys.length);
        for (var index = 1; index < sortedKeys.length; index++) {
            if (index !== Number(sortedKeys[index])) {
                key = "".concat(index);
                break;
            }
        }
        return key;
    };
    /**
     * Add value at first position
     *
     * @param {String} entry
     */
    Dequeue.prototype.unshift = function (entry) {
        // check if empty
        if (this.isEmpty()) {
            this.setEntries([entry]);
            return;
        }
        var head = this.record.get(this.headPath) || this.emptyHead;
        var key = this.getNodeKey();
        this.beforeChange();
        // set node
        this.record.set({ path: key, data: { d: entry, p: '', n: head.n } });
        // update previous first node
        if (head.n)
            this.record.set({ path: "".concat(head.n, ".p"), data: key });
        // update head
        this.record.set({ path: "".concat(this.headPath, ".n"), data: key });
        this.afterChange();
    };
    /**
     * Add value at last position
     *
     * @param {String} entry
     */
    Dequeue.prototype.push = function (entry) {
        // check if empty
        if (this.isEmpty()) {
            this.setEntries([entry]);
            return;
        }
        var head = this.record.get(this.headPath) || this.emptyHead;
        var key = this.getNodeKey();
        this.beforeChange();
        // set node
        this.record.set({ path: key, data: { d: entry, p: head.p, n: '' } });
        // update previous last node
        if (head.p)
            this.record.set({ path: "".concat(head.p, ".n"), data: key });
        // update head
        this.record.set({ path: "".concat(this.headPath, ".p"), data: key });
        this.afterChange();
    };
    /**
     * Remove a node
     */
    Dequeue.prototype.removeNode = function (nodeKey, node) {
        var head = this.record.get(this.headPath) || this.emptyHead;
        this.beforeChange();
        // update previous and next node
        if (node.p)
            this.record.set({ path: "".concat(node.p, ".n"), data: node.n });
        if (node.n)
            this.record.set({ path: "".concat(node.n, ".p"), data: node.p });
        // if last node was removed update head
        if (head.p === nodeKey) {
            this.record.set({ path: "".concat(this.headPath, ".p"), data: node.p });
        }
        // if first node was removed update head
        if (head.n === nodeKey) {
            this.record.set({ path: "".concat(this.headPath, ".n"), data: node.n });
        }
        // erase node
        this.record.set({ path: nodeKey, data: undefined });
        this.afterChange();
    };
    /**
     * Removes an entry from the list. If no index is given it will remove the first occurrence
     *
     * @param {String} entry
     * @param {Number} [index]
     */
    Dequeue.prototype.removeEntry = function (entry, index) {
        var head = this.record.get(this.headPath) || this.emptyHead;
        var next = head.n;
        var position = 0;
        while (next) {
            var node = this.record.get(next);
            if (node.d === entry) {
                if (!index) {
                    this.removeNode(next, node);
                    break;
                }
                if (index && index === position) {
                    this.removeNode(next, node);
                    break;
                }
            }
            ++position;
            next = node.n;
        }
        if (!next) {
            // got to the end without result
            throw new Error('no entry removed');
        }
    };
    /**
     * Inserts an entry in the list. At index 0 is equivalent to unshift, at index = entries.length - 1 it will be inserted before last node, unlike push.
     *
     * @param {String} entry
     * @param {Number} [index]
     */
    Dequeue.prototype.insertEntry = function (entry, index) {
        var hasIndex = this.hasIndex(index);
        if (index === 0) {
            this.unshift(entry);
            return;
        }
        if (hasIndex) {
            var head = this.record.get(this.headPath) || this.emptyHead;
            var next = head.n;
            var position = 0;
            while (next) {
                var node = this.record.get(next);
                if (index === position) {
                    var key = this.getNodeKey();
                    this.beforeChange();
                    // set node
                    this.record.set({ path: key, data: { d: entry, n: next, p: node.p } });
                    // update next node
                    this.record.set({ path: "".concat(next, ".p"), data: key });
                    // update previous node
                    if (node.p)
                        this.record.set({ path: "".concat(node.p, ".n"), data: key });
                    this.afterChange();
                    break;
                }
                ++position;
                next = node.n;
            }
            if (!next) {
                // got to the end without inserting
                throw new Error('Index out of range');
            }
        }
    };
    Dequeue.prototype.subscribe = function (positionOrCallback, callback) {
        var parameters = utils.normalizeArguments(arguments);
        if (parameters.path) {
            if (parameters.path === 'first') {
                parameters.path = "".concat(this.headPath, ".n");
            }
            else if (parameters.path === 'last') {
                parameters.path = "".concat(this.headPath, ".p");
            }
            else {
                throw new Error('Position must be "first" or "last" element');
            }
        }
        // Make sure the callback is invoked with an empty array for new records
        var listCallback = function (scope, cb) {
            if (parameters.path) {
                if (parameters.path === "".concat(scope.headPath, ".p")) {
                    cb(scope.getLast());
                }
                if (parameters.path === "".concat(scope.headPath, ".n")) {
                    cb(scope.getFirst());
                }
            }
            else {
                cb(scope.getEntries());
            }
        }.bind(this, this, parameters.callback);
        /**
        * Adding a property onto a function directly is terrible practice,
        * and we will change this as soon as we have a more seperate approach
        * of creating lists that doesn't have records default state.
        *
        * The reason we are holding a referencing to wrapped array is so that
        * on unsubscribe it can provide a reference to the actual method the
        * record is subscribed too.
        **/
        this.wrappedFunctions.set(parameters.callback, listCallback);
        parameters.callback = listCallback;
        this.subscriptions.push(parameters);
        this.record.subscribe(parameters, this);
    };
    Dequeue.prototype.unsubscribe = function (positionOrCallback, callback) {
        var parameters = utils.normalizeArguments(arguments);
        if (parameters.path) {
            if (parameters.path === 'first') {
                parameters.path = "".concat(this.headPath, ".n");
            }
            else if (parameters.path === 'last') {
                parameters.path = "".concat(this.headPath, ".p");
            }
            else {
                throw new Error('Position must be "first" or "last" element');
            }
        }
        var listenCallback = this.wrappedFunctions.get(parameters.callback);
        parameters.callback = listenCallback;
        this.wrappedFunctions.delete(parameters.callback);
        this.subscriptions = this.subscriptions.filter(function (subscription) {
            if (!parameters.callback && (subscription.path === parameters.path))
                return false;
            if (parameters.callback && (subscription.path === parameters.path && subscription.callback === parameters.callback))
                return false;
            return true;
        });
        this.record.unsubscribe(parameters, this);
    };
    /**
     * Proxies the underlying Record's _update method.
     */
    Dequeue.prototype.applyUpdate = function (message) {
        this.beforeChange();
        this.originalApplyUpdate(message);
        this.afterChange();
    };
    /**
     * Validates that the index provided is within the current set of entries.
     */
    Dequeue.prototype.hasIndex = function (index) {
        var hasIndex = false;
        var entries = this.getEntries();
        if (index !== undefined) {
            if (isNaN(index)) {
                throw new Error('Index must be a number');
            }
            if (index !== entries.length && (index >= entries.length || index < 0)) {
                throw new Error('Index must be within current entries');
            }
            hasIndex = true;
        }
        return hasIndex;
    };
    /**
     * Establishes the current structure of the list, provided the client has attached any
     * add / move / remove listener
     *
     * This will be called before any change to the list, regardsless if the change was triggered
     * by an incoming message from the server or by the client
     */
    Dequeue.prototype.beforeChange = function () {
        this.hasAddListener = this.hasListeners(constants_1.EVENT.ENTRY_ADDED_EVENT);
        this.hasRemoveListener = this.hasListeners(constants_1.EVENT.ENTRY_REMOVED_EVENT);
        this.hasMoveListener = this.hasListeners(constants_1.EVENT.ENTRY_MOVED_EVENT);
        if (this.hasAddListener || this.hasRemoveListener || this.hasMoveListener) {
            this.beforeStructure = this.getStructure();
        }
        else {
            this.beforeStructure = null;
        }
    };
    /**
     * Compares the structure of the list after a change to its previous structure and notifies
     * any add / move / remove listener. Won't do anything if no listeners are attached.
     */
    Dequeue.prototype.afterChange = function () {
        if (this.beforeStructure === null) {
            return;
        }
        var after = this.getStructure();
        var before = this.beforeStructure;
        var entry;
        var i;
        if (this.hasRemoveListener) {
            for (entry in before) {
                for (i = 0; i < before[entry].length; i++) {
                    if (after[entry] === undefined || after[entry][i] === undefined) {
                        this.emit(constants_1.EVENT.ENTRY_REMOVED_EVENT, entry, before[entry][i]);
                    }
                }
            }
        }
        if (this.hasAddListener || this.hasMoveListener) {
            for (entry in after) {
                if (before[entry] === undefined) {
                    for (i = 0; i < after[entry].length; i++) {
                        this.emit(constants_1.EVENT.ENTRY_ADDED_EVENT, entry, after[entry][i]);
                    }
                }
                else {
                    for (i = 0; i < after[entry].length; i++) {
                        if (before[entry][i] !== after[entry][i]) {
                            if (before[entry][i] === undefined) {
                                this.emit(constants_1.EVENT.ENTRY_ADDED_EVENT, entry, after[entry][i]);
                            }
                            else {
                                this.emit(constants_1.EVENT.ENTRY_MOVED_EVENT, entry, after[entry][i]);
                            }
                        }
                    }
                }
            }
        }
    };
    /**
     * Iterates through the list and creates a map with the entry as a key
     * and an array of its position(s) within the list as a value, e.g.
     *
     * {
     *   'recordA': [ 0, 3 ],
     *   'recordB': [ 1 ],
     *   'recordC': [ 2 ]
     * }
     */
    Dequeue.prototype.getStructure = function () {
        var structure = {};
        var i;
        var entries = this.getEntries();
        for (i = 0; i < entries.length; i++) {
            if (structure[entries[i]] === undefined) {
                structure[entries[i]] = [i];
            }
            else {
                structure[entries[i]].push(i);
            }
        }
        return structure;
    };
    Dequeue.prototype.destroy = function () {
        for (var i = 0; i < this.subscriptions.length; i++) {
            this.record.unsubscribe(this.subscriptions[i], this);
        }
        this.wrappedFunctions.clear();
        this.record.removeContext(this);
    };
    return Dequeue;
}(emitter_1.Emitter));
exports.Dequeue = Dequeue;
